<template>
    <div class="carousel-main">
        <carousel
                :items="1"
                :loop="true"
                :autoplay="true"
                :nav="false"
        >
            <div class="carousel-main__item">
                <img :src="require('@/assets/slide_bg.png')" alt="">
                <div class="carousel-main__item-info">
                    <div class="carousel-main__item-text">
                        <div class="carousel-main__item-prod">iPhone 11</div>
                        уже в наличии
                    </div>
                    <button class="carousel-main__item-button">Купить</button>
                </div>
            </div>
            <div class="carousel-main__item">
                <img :src="require('@/assets/slide_bg.png')" alt="">
                <div class="carousel-main__item-info">
                    <div class="carousel-main__item-text">
                        <div class="carousel-main__item-prod">iPhone 11</div>
                        уже в наличии
                    </div>
                    <button class="carousel-main__item-button">Купить</button>
                </div>
            </div>
            <div class="carousel-main__item">
                <img :src="require('@/assets/slide_bg.png')" alt="">
                <div class="carousel-main__item-info">
                    <div class="carousel-main__item-text">
                        <div class="carousel-main__item-prod">iPhone 11</div>
                        уже в наличии
                    </div>
                    <button class="carousel-main__item-button">Купить</button>
                </div>
            </div>

            <template slot="prev">
                <span class="prev">
                    <arrow-left-icon size="1x" class="custom-class"></arrow-left-icon>
                </span>
            </template>
            <template slot="next">
                <div class="next">
                    <arrow-right-icon size="1x" class="custom-class"></arrow-right-icon>
                </div>
            </template>
        </carousel>
    </div>
</template>

<script>
    import Carousel from 'vue-owl-carousel';
    import { ArrowLeftIcon, ArrowRightIcon } from 'vue-feather-icons'


    export default {
        name: "CarouselMain",
        components: { Carousel, ArrowLeftIcon, ArrowRightIcon }
    }
</script>

<style scoped lang="scss">
    .carousel-main {
        box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        position: relative;
        width: 100%;
        height: 100%;
        /*margin-top: 24px;*/
        &__item {
            border-radius: 4px;
            /*background-image: url("assets/slide_bg.png");*/
            &-info {
                position: absolute;
                left: 48px;
                top: 50%;
                transform: translateY(-50%);
            }
            height: 384px;
            &-text {
                font-weight: 500;
                font-size: 38px;
                color: #3F4450;
                max-width: 280px;
            }
            &-button {
                background: linear-gradient(80.98deg, #7AC3C1 0%, #3FB0AB 100%);
                border: none;
                border-radius: 5px;
                color: #FCFCFC;
                font-size: 16px;
                padding: 8px 24px;
                margin-top: 32px;
                cursor: pointer;
            }
        }

        .next {
            display: flex;
            justify-content: center;
            align-items: center;
            background: linear-gradient(86.51deg, #7AC3C1 0%, #3FB0AB 100%);
            border-radius: 50%;
            height: 32px;
            width: 32px;
            position: absolute;
            bottom: 15px;
            z-index: 100;
            right: 24px;
            cursor: pointer;
            svg {
                color: #fff;
                font-weight: 300;
            }
        }
        .prev {
            display: flex;
            justify-content: center;
            align-items: center;
            background: linear-gradient(86.51deg, #7AC3C1 0%, #3FB0AB 100%);
            border-radius: 50%;
            height: 32px;
            width: 32px;
            position: absolute;
            bottom: 15px;
            z-index: 100;
            right: 56px;
            cursor: pointer;
            svg {
                color: #fff;
                font-weight: 300;
            }
        }
    }
</style>
